'use strict';

import footerTaglineTemplate from './footerTagline.html';

export const footerTaglineDirName = 'footerTagline';
export function footerTaglineDir() {
  return {
    restrict: 'E',
    template: footerTaglineTemplate
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/footerTagline/footerTagline.js